import { Wizard } from "react-use-wizard";
import MarathonCart from "./MarathonCart";
import MembersList from "./MembersList";
import { useQuery } from "@tanstack/react-query";
import { fetchAllMembers } from "@/api/apiFunction";
import { useMarathonCartStore } from "@/lib/checkoutDetails/checkoutDetails";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Member } from "@/lib/utils";
import Loader from "@/Loader/Loader";
import Cookies from "js-cookie";
import { useStore } from "@/lib/userDetails/UserDetails";

const Stepper = () => {
  const navigate = useNavigate();
  const { selectedUsers, addSelectedUser, updateUser } = useMarathonCartStore();
  const { setUser, setAuthenticated } = useStore();

  const {
    data: allMembersData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["all-members"],
    //@ts-ignore
    queryFn: () => fetchAllMembers(selectedUsers, addSelectedUser, updateUser),
  });

  useEffect(() => {
    if (allMembersData) {
      allMembersData.forEach((member: Member) => {
        if (member.isPrimary) {
          switch (member?.user?.state) {
            case "USER_DETAILS":
              toast.error("Please complete your profile first");
              navigate("/my-profile");
              break;
            case "EMAIL":
              Cookies.remove("token");
              //@ts-ignore
              setUser(null);
              setAuthenticated(false);
              toast.error("Please verify your email first");
              navigate("/auth/verify-email");
              break;
            case "MOBILE":
              Cookies.remove("token");
              //@ts-ignore
              setUser(null);
              setAuthenticated(false);
              toast.error("Please verify your mobile first");
              navigate("/auth/login/mobile");
              break;
            default:
              break;
          }
        }
      });
    }
  }, [allMembersData, navigate]);

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <div>Error loading members data</div>;
  }
  return (
    <Wizard>
      <MarathonCart />

      {allMembersData && (
        <MembersList
          // @ts-ignore
          allMembersData={allMembersData}
        />
      )}
    </Wizard>
  );
};

export default Stepper;
